import { Button, message } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import DynamicTable from "../../components/DynamicTable";
import AssignVehicleModal from "./components/AssignVehicleModal";
import { useDispatch, useSelector } from "react-redux";
import { getRideRequests, updateRideRequest } from "../../actions/ride";

function RideRequets() {
  const rideRequests = useSelector((state) => state.ride?.requests);
  const [showAssignVehicle, setShowAssignVehicle] = useState(null);
  const dispatch = useDispatch();

  const DEFAULT_COLUMNS = {
    id: {
      show: true,
      label: "Ride Id",
      key: "id",
    },
    user: {
      show: true,
      label: "User",
      key: "user",
    },
    campus: {
      show: true,
      label: "Campus",
      key: "campus",
    },
    start_dock: {
      show: true,
      label: "Start Dock",
      key: "start_dock",
    },
    end_dock: {
      show: true,
      label: "End Dock",
      key: "start_dock",
    },
    vehicle: {
      show: true,
      label: "Vehicle",
      key: "vehicle",
    },
    driver: {
      show: true,
      label: "Driver",
      key: "driver",
    },
    charges: {
      show: true,
      label: "Charges",
      key: "charges",
    },
    request_time: {
      show: true,
      label: "Request Time",
      key: "request_time",
    },
  };

  useEffect(() => {
    fetchRideRequests();
  }, []);

  const fetchRideRequests = async () => {
    const res = await dispatch(getRideRequests());
    if (res.error) {
      message.error(res.error_description);
    }
  };

  const COLUMNS = [
    {
      title: "Ride Id",
      dataIndex: "id",
      fixed: "left",
      width: 100,
      filterType: "search",
    },
    {
      title: "User",
      dataIndex: "user.user_email",
      width: 140,
      filterType: "search",
      render: (_, record) => (
        <div style={{ fontSize: 11 }}>{record.user?.user_email}</div>
      ),
    },
    {
      title: "Campus",
      dataIndex: "campus",
      width: 140,
      render: (_, record) => (
        <div style={{ fontSize: 11 }}>{record.start_dock?.campus?.name}</div>
      ),
    },
    {
      title: "Start Dock",
      dataIndex: "start_dock.name",
      width: 140,
      filterType: "search",
      render: (_, record) => (
        <div style={{ fontSize: 11 }}>{record.start_dock?.name}</div>
      ),
    },
    {
      title: "End Dock",
      dataIndex: "end_dock.name",
      width: 140,
      filterType: "search",
      render: (_, record) => (
        <div style={{ fontSize: 11 }}>{record.end_dock?.name}</div>
      ),
    },
    {
      title: "Vehicle",
      dataIndex: "vehicle.code",
      width: 140,
      filterType: "search",
      render: (_, row) => (
        <>
          {row.status === "requested" ? (
            <span style={{ color: "orange" }}>{"not-assigned"}</span>
          ) : (
            <>
              <div style={{ fontSize: 11 }}>{row.vehicle?.name}</div>
              {/* <div style={{ fontSize: 11 }}>{row.vehicle?.code}</div> */}
            </>
          )}
        </>
      ),
    },
    {
      title: "Driver",
      dataIndex: "driver.user_email",
      width: 140,
      filterType: "search",
      render: (_, row) => (
        <>
          {row.status === "requested" ? (
            <span style={{ color: "orange" }}>{"not-assigned"}</span>
          ) : (
            <>
              <div style={{ fontSize: 11 }}>{row.driver?.user_email}</div>
            </>
          )}
        </>
      ),
    },
    {
      title: "Charges",
      dataIndex: "charges",
      width: "90px",
      render: (cost) => {
        return <div>{cost}</div>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "90px",
      render: (status) => {
        const colors = {
          requested: "blue",
          booked: "green",
        };
        return <div style={{ color: colors[status] }}>{status}</div>;
      },
    },
    {
      title: "Updated Time",
      dataIndex: "request_time",
      width: "150px",
      filterType: "date",
      render: (_, record) => {
        let value =
          record.status == "requested"
            ? record.requested_time
            : record.booked_time;
        return <div>{moment(value).format("DD-MM-YYYY HH:mm")}</div>;
      },
    },
  ];

  const handleRideUpdate = (ride) => {
    dispatch(updateRideRequest(ride));
    setShowAssignVehicle(null);
  };

  return (
    <div style={{ height: "80vh" }}>
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={Object.values(rideRequests)}
          columns={COLUMNS}
          defaultColumns={DEFAULT_COLUMNS}
          scroll={{ y: "65vh" }}
          pagination={{
            pageSize: 200,
          }}
          showAction={() => false}
          renderAction={(record) => {
            if (record.status !== "requested") {
              return null;
            }
            return (
              <Button
                onClick={() => {
                  setShowAssignVehicle({
                    ...record,
                  });
                }}
                size="small"
              >
                Assign
              </Button>
            );
          }}
        />
      </div>
      {showAssignVehicle ? (
        <AssignVehicleModal
          rideId={showAssignVehicle.id}
          isCancel={true}
          rideData={showAssignVehicle}
          onUpdated={(res) => {
            handleRideUpdate(res);
          }}
          onCancel={() => {
            setShowAssignVehicle(null);
          }}
          open={true}
        />
      ) : null}
    </div>
  );
}

export default RideRequets;
